import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance

export const getViewMeetingDetailsById = (meetingId) => {
    return API(Endpoints.API_ENDPOINT)
        .get(`${Endpoints.GET_VIEW_MEETING_BY_ID}/${meetingId}`)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const GetUpcommingEvents = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_UPCOMING_EVENTS)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createMeeting = (meetingData) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_NEW_MEETING, meetingData)
        .then((response) => response)
        .catch((err) => err)
}
